import mitt from "mitt";
import { FC, PropsWithChildren } from "react";

import {
  CompanyScopeContext,
  ICompanyScopeContext,
  useAuth,
  useCompanyScopeCtxProvider,
} from "@ryde/redux";
import { GlobalAppEvents } from "@ryde/shared";

interface ICompanyScopeContextWrapperProps extends PropsWithChildren {
  isHybridWidgetMode?: boolean;
}

export const CompanyScopeContextWrapper: FC<
  ICompanyScopeContextWrapperProps
> = ({ children, isHybridWidgetMode }) => {
  useCompanyScopeCtxProvider();
  const auth = useAuth();
  const eventEmitter = mitt<GlobalAppEvents>();

  const contextData: ICompanyScopeContext = {
    auth,
    isHybridWidgetMode: isHybridWidgetMode || false,
    eventEmitter,
  };
  return (
    <CompanyScopeContext.Provider value={contextData}>
      {children}
    </CompanyScopeContext.Provider>
  );
};
